export default {
  questionnaire_details:'问卷详情',
  questionnaire_submit_success:"问卷已提交成功",
  questionnaire_bcak_list:'返回问卷列表',
  questionnaire_no:'还没有问卷',
}
